export enum RSSClockPlacement {
  Left,
  Right
}
